module.exports = __webpack_public_path__ + "static/img/iphonex@2x.ab75444.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/applicationDiscount/iphonex@2x.png
// module id = VvVM
// module chunks = 70